import { Button } from "@msuite/ui/button";
import type { Disclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";

/** Props Interface */
interface InsightsSpotlightTriggerProps {
	disclosure: Disclosure;
}

export function InsightsSpotlightTrigger({ disclosure }: InsightsSpotlightTriggerProps) {
	const { t } = useTranslation();

	/** Render */
	return (
		<Button
			variant="white"
			icon={
				<Icon
					name="Astroid"
					className="stroke-accent-500 fill-accent-500/10"
				/>
			}
			onClick={disclosure.onOpen}
			className="rounded-full"
		>
			{t("insights.ask_ai")}
		</Button>
	);
}
